import {useState} from "react"
import {useHistory} from "react-router-dom"
import {head} from "lodash"
import {BasePopup} from "components/popup"
import {BaseButton} from "components/buttons"
import {KlassDropdown} from "components/Select"
import {FormLabel} from "components/Form"
import {useMutation} from "hooks"
import {taskService} from "services"
import {handleError, toastSuccess} from "helpers"
import styles from "./AssignMultiTaskPopup.module.css"

type StudentInfo = {
    profileId: number
    termId: number
    courseId: number
    scheduleId: number
}

type Props = {
    isShow: boolean
    students: StudentInfo[]
    edularTasks: any[]
    onClose: () => void
}

export function AssignMultiTaskPopup(props: Props) {
    const {isShow, students, edularTasks, onClose} = props
    const [activeTask, setActiveTask] = useState(null)
    const history = useHistory()

    const assignTaskMutation = useMutation(
        async () =>
            await Promise.all(
                students.map((item) =>
                    taskService.assignCustomDigitalTask({
                        taskId: activeTask.taskId,
                        profileId: item.profileId,
                        courseId: item.courseId,
                        scheduleId: item.scheduleId,
                        termId: item.termId
                    })
                )
            ),
        {
            onSuccess: (data) => {
                toastSuccess("Assign task successful")
                const taskIds = data.map((item) => item.id)
                history.push({
                    pathname: `/tasks/submissions`,
                    search: `id=${head(taskIds)}&type=customDD&relatedTaskIds=${taskIds}`,
                    state: {
                        backUrl: `${history.location.pathname}${history.location.search}`
                    }
                })
            },
            onError: (error) => {
                handleError(error)
            }
        }
    )

    const handleClose = () => {
        onClose()
        setActiveTask(null)
    }

    return (
        <BasePopup isShow={isShow} onClose={handleClose} leftIcon="EDIT_LINE" width="60vw">
            <div className={styles.wrap}>
                <p className={styles.title}>Assign Tasks</p>
                <div>
                    <FormLabel label="Select task" isRequired />
                    <KlassDropdown options={edularTasks} valueKey="taskId" onChange={setActiveTask} />
                </div>
                <div className={styles.action}>
                    <BaseButton
                        title="Cancel"
                        variant="secondary"
                        onClick={onClose}
                        disabled={assignTaskMutation.isLoading}
                    />
                    <BaseButton
                        title="Assign"
                        disabled={!activeTask}
                        onClick={assignTaskMutation.mutate}
                        loading={assignTaskMutation.isLoading}
                    />
                </div>
            </div>
        </BasePopup>
    )
}
